const prefixoOperador = "/operador";
const privilegioOperador = [10];
import auth from "../middleware/auth";

export default [
    {
        path: `${prefixoOperador}/questao-por-ia`,
        name: "operador-questao-por-ia",
        component: () => import("../pages/operador/questao-por-ia/Home.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioOperador,
        },
    },
    {
        path: `${prefixoOperador}/questao-por-ia/criar`,
        name: "operador-questao-por-ia",
        component: () => import("../pages/operador/questao-por-ia/CriarQuestao.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioOperador,
        },
    },
    {
        path: `${prefixoOperador}/questao-por-ia/editar/:id`,
        name: "operador-questao-por-ia",
        component: () => import("../pages/operador/questao-por-ia/EditarQuestao.vue"),
        beforeEnter: auth,
        meta: {
            id_privilegio: privilegioOperador,
        },
    }
];